import { realBricksApi } from '../../utils/axiosInterceptors';

export const getAccountBalances = async () => {
  const response = await realBricksApi.get(`/api/v1/user/account-balances`);
  return response.data;
};

export const getTransactionsDetails = async (filter) => {
  const { page, perPage, transactionType, toDate, fromDate, shareType } = filter;
  const url = `/api/v1/user/transactions?${`page=${page}`}${perPage && `&perPage=${perPage}`}${toDate && `&toDate=${toDate}`}${
    fromDate && `&fromDate=${fromDate}`}${transactionType && `&transactionType=${transactionType}`}${shareType && `&shareType=${shareType}`}`;
  const response = await realBricksApi.get(url);
  return response.data;
};

export const cancelTransfer = async (id) => {
  const response = await realBricksApi.post(`/api/v1/payment/cancel-transfer/${id}`);
  return response.data;
}
